import { render, staticRenderFns } from "./AddMealDemand.vue?vue&type=template&id=f85f20b0"
import script from "./AddMealDemand.vue?vue&type=script&lang=js"
export * from "./AddMealDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports